import React, { Component } from 'react'
import { observer } from 'mobx-react'
import SaveButton from 'app/components/buttons/_save'
import form from 'modules/ticketPublicPage/stores/tickets/form'

@observer
class PurchaseError extends Component {
  render () {
    const { buyAnotherTicket } = form
    return (
      <React.Fragment>
        {i18n.gettext('Sorry but we are unable to purchase tickets, please try again.')}
        <SaveButton onClick={buyAnotherTicket} />
      </React.Fragment>
    )
  }
}

export default PurchaseError
